import { render } from "./addModuleShopRecharge.vue?vue&type=template&id=2671f26c"
import script from "./addModuleShopRecharge.vue?vue&type=script&lang=js"
export * from "./addModuleShopRecharge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__